<template>
  <v-container fluid>
    <h1>survey page</h1>
    <v-card>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Amet, quia!</p>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const messages = ref([
  { id: '1', initials: 'JS', title: 'John Smith', time: '2h' },
  { id: '2', initials: 'ML', title: 'Mary Lane', time: '1d' },
])
</script>